export function getOwnProfileId(user) {
  const profileId = user?.profile?.id ?? user?.profile_id;
  if (profileId == null || profileId === '') {
    return null;
  }
  return Number(profileId);
}

export function isOwnAssignedProfile(user, profileId) {
  const ownProfileId = getOwnProfileId(user);
  if (ownProfileId == null || profileId == null || profileId === '') {
    return false;
  }
  return Number(profileId) === ownProfileId;
}

export function excludeOwnAssignedProfile(user, profiles = []) {
  const ownProfileId = getOwnProfileId(user);
  if (ownProfileId == null) {
    return profiles;
  }
  return profiles.filter((profile) => Number(profile?.id) !== ownProfileId);
}
